// Phase 6 — Track E T-E3. EmptyState primitive (hand-rolled).
//
// Centred icon + title + description + optional CTA. Used for
// "no payments yet", "no upcoming dates" surfaces. Never apologises;
// per blueprint §13.4 the copy stays neutral and direct.

import * as React from 'react';
import { cn } from '../../lib/cn.js';

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, icon, title, description, action, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-live="polite"
      className={cn(
        'flex flex-col items-center justify-center text-center gap-3 py-12 px-6',
        className,
      )}
      {...props}
    >
      {icon && <div className="text-text-muted">{icon}</div>}
      <h2 className="text-title-3 text-text-primary">{title}</h2>
      {description && <p className="text-body text-text-secondary max-w-md">{description}</p>}
      {action && <div className="pt-2">{action}</div>}
    </div>
  ),
);
EmptyState.displayName = 'EmptyState';
